import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToSection } from "@/constants";

const fade = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-32 lg:py-40 bg-[#2C2A29] text-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <motion.p {...fade} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-[#D9734E]">
            Engagements
          </motion.p>
          <motion.h2 {...fade} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6">
            Professional development built around <span className="italic text-[#D9734E]">your organization.</span>
          </motion.h2>
          <motion.div {...fade} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="mt-8 space-y-6 max-w-xl text-base sm:text-lg leading-relaxed font-light text-[#FAF9F6]/75">
            <p>
              Every engagement is customized based on audience, organizational
              goals, existing technology, and desired outcomes.
            </p>
            <p>
              Phillip works with organizations seeking meaningful professional
              development rather than one-size-fits-all presentations.
            </p>
          </motion.div>
          <motion.button
            {...fade}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            onClick={() => scrollToSection("#contact")}
            data-testid="pricing-cta-button"
            className="mt-12 inline-flex items-center gap-3 rounded-full bg-[#D9734E] text-white px-8 py-4 font-semibold hover:-translate-y-1 hover:shadow-lg hover:shadow-[#D9734E]/25 transition-transform duration-300"
          >
            Request Engagement Information
            <ArrowRight className="w-5 h-5" />
          </motion.button>
        </div>

        <motion.div {...fade} transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }} className="lg:col-span-5 lg:col-start-8 self-center space-y-10">
          <div data-testid="pricing-pd" className="border-l-2 border-[#D9734E] pl-8">
            <div className="font-display text-5xl sm:text-6xl tracking-tight">$7,500<span className="text-2xl align-top">+</span></div>
            <p className="mt-3 text-sm text-[#FAF9F6]/65">Typical professional development engagements begin at $7,500.</p>
          </div>
          <div data-testid="pricing-fullday" className="border-l-2 border-[#FAF9F6]/20 pl-8">
            <div className="font-display text-5xl sm:text-6xl tracking-tight">$12,500<span className="text-2xl align-top">+</span></div>
            <p className="mt-3 text-sm text-[#FAF9F6]/65">Full-day organizational programs typically begin at $12,500.</p>
          </div>
          <p className="text-sm text-[#FAF9F6]/55 pl-8">
            Multi-session and organization-wide engagements are quoted based on scope.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
